<template>
	<div class="md-layout text-center login-fix-page">
		<div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100 login-page-fix">
			<form @submit.prevent="login">
				<login-card header-color="green">
					<h4 slot="title" class="title font-medium mb-0">GAIA - Espace client</h4>
					<md-field class="form-group md-invalid" slot="inputs" style="margin-bottom: 28px">
						<label>Nom d'utilisateur</label>
						<md-input v-model="username" type="text"/>
					</md-field>
					<md-field class="form-group md-invalid" slot="inputs">
						<label>Mot de passe</label>
						<md-input v-model="password" type="password"/>
					</md-field>
					<span class="text-sm text-danger font-normal -mt-3 -mb-1" slot="error">{{ error }}</span>
					<md-button slot="footer" class="md-success font-medium" type="submit">
						Connexion
					</md-button>
				</login-card>
			</form>
		</div>
	</div>
</template>

<script>
import { LoginCard } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
	name: "ClientsAreaLogin",
	components: {
		LoginCard,
	},
	mixins: [formMixin],
	data: () => ({
		username: "",
		password: "",
		error: ""
	}),
	computed: {
		clientAreaAuthenticated: function () {
			return this.$store.getters.clientAreaAuthenticated();
		},
	},
	methods: {
		async login() {
			this.error = ''
			const user = {
				data: {
					type: "token",
					attributes: {
						username: this.username,
						password: this.password,
					},
				},
			};

			const requestOptions = {
				headers: {
					Accept: "application/vnd.api+json",
					"Content-Type": "application/vnd.api+json",
				},
			};

			try {
				this.resetApiValidation();
				let { data } = await this.$store.dispatch("caLogin", { user, requestOptions });
                const clientArea = {
                    accessToken: data.accessToken,
                    userType: data.userType
                }
                localStorage.setItem("client-area", JSON.stringify(clientArea))
				await this.$router.push({ name: 'caDashboard' })
			} catch (e) {
				this.error = 'Une erreur est survenue - Connexion impossible'
			}
		},
	}
}
</script>

<style scoped>

</style>
